import React from 'react';

interface DataPointProps {
  label: string;
  value?: React.ReactNode;
}

const DataPoint = ({
  label,
  value,
}: DataPointProps) => (
  <div className="d-flex mb-2">
    {label && (
      <span className="font-weight-bold mr-2">
        {label}:
      </span>
    )}

    {value !== undefined && (
      <span>
        {value}
      </span>
    )}
  </div>
);

DataPoint.defaultProps = {
  value: undefined,
};

export default DataPoint;
